export default __webpack_public_path__ + "static/media/Trickle.a055dc55.svg";